import CheckmateApiClient from '../../services/apiClient';
import { LookupDataEnums } from '../../utilities/Constants';
import { useQuery } from 'react-query';

const _apiClient = new CheckmateApiClient();

export const useGetJurisdictions = (
    caseFileModelId?: number
) => {
    return useQuery({
        queryKey: ['get-jurisdictions', { caseFileModelId }],
        queryFn: async () => {
            const response = await _apiClient.getAdminLookupData(caseFileModelId ?? 0, LookupDataEnums.Jurisdictions);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve jurisdictions.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        cacheTime: Infinity,
        staleTime: Infinity,
        enabled: !!caseFileModelId,
    });
};
